// Full-width image banner used at the top of inner pages.
export default function PageHero({ image, alt = '', eyebrow, title, lead, action }) {
  return (
    <section className="relative overflow-hidden bg-ink pt-[84px] text-paper">
      <img src={image} alt={alt} className="absolute inset-0 h-full w-full animate-kenburns object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink/90 via-ink/65 to-ink/25" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-ink/60 to-transparent" />
      <div className="wrap relative py-24 md:py-36">
        <p className="eyebrow animate-fade-up text-brass-light">{eyebrow}</p>
        <span className="rule-light mt-5 animate-fade-up" />
        <h1 className="display mt-7 max-w-[17ch] animate-fade-up [animation-delay:150ms]">{title}</h1>
        <p className="mt-6 max-w-[52ch] animate-fade-up text-[1.08rem] text-paper/85 [animation-delay:300ms]">{lead}</p>
        {action && <a href={action.href} className="btn btn-gold mt-9 animate-fade-up [animation-delay:450ms]">{action.label}</a>}
      </div>
    </section>
  );
}
